import React from "react";
import { BlockGame, GroupingGame, MatchGame, MergeGame, SudokuGame, TicTacToeGame, WordGame } from "./puzzleGames";
import { FlyerGame, RunnerGame, ShooterGame, SliceGame, SlingshotGame, SpaceGame } from "./arcadeGames";
import { TowerGame } from "./strategyGames";

const games = {
  match: MatchGame,
  runner: RunnerGame,
  flyer: FlyerGame,
  tower: TowerGame,
  slingshot: SlingshotGame,
  slice: SliceGame,
  merge: MergeGame,
  word: WordGame,
  blocks: BlockGame,
  sudoku: SudokuGame,
  tictactoe: TicTacToeGame,
  grouping: GroupingGame,
  shooter: ShooterGame,
  space: SpaceGame,
};

export const resolveGameFamily = (gameKey) => games[gameKey?.split("/")[0]] ? gameKey.split("/")[0] : null;

export default function GameHub(props) {
  const family = resolveGameFamily(props.game.demo.gameKey);
  const Game = games[family];
  if (!Game) return <div className="game-error">This demo is unavailable.</div>;
  return <Game {...props} />;
}
